
export default "/assets/link-micro.a56c6ba7.svg"